import { render } from "./ActorSwiper.vue?vue&type=template&id=7b16d231&scoped=true"
import script from "./ActorSwiper.vue?vue&type=script&lang=js"
export * from "./ActorSwiper.vue?vue&type=script&lang=js"

import "./ActorSwiper.vue?vue&type=style&index=0&id=7b16d231&lang=scss&scoped=true"

import exportComponent from "/Applications/XAMPP/xamppfiles/htdocs/studioemme/wp-content/themes/studioemme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b16d231"]])

export default __exports__